import React from 'react';
import { useIntl } from 'react-intl';
import { ErrorNotification } from '@hqo/react-components-library/dist/molecules/errorNotification';
import { HqoTheme, HqoThemeProvider } from '@hqo/react-components-library/dist/hqo-theme-provider';

import { useGetTheme } from 'hooks/use-get-theme.hook';
import { ErrorWrapper } from 'pages/error/styles';

interface UserConnectionErrorProps {
  onRetry: VoidFunction;
}

/**
 * Rendered by `App` ahead of `<Router/>`, so outside the app's only theme provider (inside the
 * router's `AppContentWrapper`): it brings its own, or RCL's styles throw on an empty theme.
 * Not `ErrorPage`, whose button goes back; on a deeplink there is nothing behind this screen.
 */
export const UserConnectionError = ({ onRetry }: UserConnectionErrorProps): JSX.Element => {
  const intl = useIntl();
  const theme = useGetTheme();

  return (
    <HqoThemeProvider theme={theme as HqoTheme}>
      <ErrorWrapper role="alert" data-testid="user-connection-error">
        <ErrorNotification
          title={intl.formatMessage({ id: 'something_went_wrong' })}
          description={intl.formatMessage({ id: 'server_unreachable_description' })}
          buttonText={intl.formatMessage({ id: 'try_again' })}
          onClick={onRetry}
          showButton
        />
      </ErrorWrapper>
    </HqoThemeProvider>
  );
};
